<template>
  <div>
    <section>
      <v-container container--fluid grid-list-md>
        <v-row>
          <v-col cols="12">
            <h1>Zones</h1>
          </v-col>
        </v-row>

        <v-row justify="space-between" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
          <v-col cols="12" sm="12" md="3">
            <v-text-field label="Search..." v-model="search" prepend-icon="search"></v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="1" class="text-center">
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-btn text large @click="updateDataTable" v-on="on">
                  <v-icon color="cyan darken-2">refresh</v-icon>
                </v-btn>
              </template>
              <span>Refresh</span>
            </v-tooltip>
          </v-col>

          <v-col cols="12" sm="12" md="2" class="text-center">
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-btn @click="newDepot" class="mx-2" fab dark color="blue lighten-1" v-on="on">
                  <v-icon dark>add</v-icon>
                </v-btn>
              </template>
              <span>Create a new zone</span>
            </v-tooltip>
          </v-col>

        </v-row>
      </v-container>
      <v-divider></v-divider>
      <v-data-table
        :search="search"
        :headers="headers"
        :items="renderedZones"
        :loading="loading"
      >
        <template v-slot:item="props">
          <tr v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
            <td v-if="header.text !== 'Actions'" style="text-align: center" v-for="(header, index) in headers"
                :key="index">{{props.item[header.value]}}
            </td>
            <td v-else class="text-center">
              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on }">
                  <v-icon @click="editRow(props.item)" color="blue" v-on="on">
                    edit
                  </v-icon>
                </template>
                <span>Edit</span>
              </v-tooltip>
              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on }">
                  <v-icon @click="deleteRow(props.item)" color="red" v-on="on" class="pl-1">
                    delete
                  </v-icon>
                </template>
                <span>Delete</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>

    </section>

    <v-dialog
      v-model="zoneDialog"
      max-width="400px"
    >
      <v-card>
        <v-card-title>
          <h3>{{editedIndex > -1 ? 'Edit zone ' + zoneItem.id : 'New zone'}}</h3>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="zoneItem.name"
            label="Zone name"
            prepend-icon="fa fa-store-alt"
          ></v-text-field>
          <v-select
            label="Choose a region"
            :items="regions"
            item-text="name"
            item-value="id"
            v-model="zoneItem.region_id"
            prepend-icon="fas fa-map-marked-alt"
          ></v-select>
          <v-select
            label="Choose a depot"
            :items="depots"
            item-text="name"
            item-value="id"
            v-model="zoneItem.depot_id"
            prepend-icon="fas fa-map-marked-alt"
          ></v-select>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            text
            @click="closeZonesDialog"
            color="blue-grey lighten-2"
          >Cancel
          </v-btn>
          <v-btn
            text
            @click="saveChanges"
            color="blue darken-1"
          >Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="justify-center">
          <h3>ATTENTION</h3>
        </v-card-title>
        <v-card-text class="text-center">
          You are about to delete this depot. This action cannot be undone. <br>
          Are you sure you want to proceed ?
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text @click="toBeDeleted=null; deleteDialog=false" color="blue-grey lighten-2">No</v-btn>
          <v-btn text @click="deleteZone" color="blue darken-1">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>

</template>

<script>
    import axios from 'axios';

    export default {
        name: "ManageZone",
        data() {
            return {
                search: '',
                loading: false,
                reload: false,
                timer: '',
                headers: [
                    {text: 'Id', value: 'id', align: 'center', sortable: true},
                    {text: 'Name', value: 'name', align: 'center', sortable: true},
                    {text: 'Region name', value: 'region_name', align: 'center', sortable: true},
                    {text: 'Depot name', value: 'depot_name', align: 'center', sortable: true},
                    {text: 'Actions', value: 'actions', align: 'center', sortable: false}
                ],
                zoneDialog: false,
                editedIndex: -1,
                toBeDeleted: null,
                deleteDialog: false,
                regions: [],
                depots: [],
                zoneItem: {
                    region_id: null,
                    depot_id: null,
                    name: null,
                },
                default: {
                    region_id: null,
                    depot_id: null,
                    name: null,
                },

            }
        },
        mounted: function () {
            this.timer = setInterval(() => {
                this.reload = !this.reload;
            }, 300000)
            this.getRegions();
            this.getDepots();
        },
        beforeDestroy() {
            clearInterval(this.timer)
        },
        computed: {
            renderedZones() {
                if (this.Zones === null || this.Zones === undefined) {
                    return [];
                } else {
                    return this.Zones;
                }
            },
        },
        asyncComputed: {
            async Zones() {
                if (this.reload || !this.reload) {
                    this.loading = true;
                    return await axios.get(process.env.API_URL + '/zones')
                        .then((response) => {
                            if (response.status === 200) {
                                this.loading = false;
                                return response.data;
                            } else {
                                this.loading = false;
                                return [];
                            }
                        })
                        .catch((error) => {
                            this.loading = false;
                            return [];
                        });
                }
            }
        },
        methods: {
            updateDataTable() {
                this.reload = !this.reload;
            },
            newDepot() {
                this.editedIndex = -1;
                this.zoneItem = Object.assign({}, this.default);
                this.zoneDialog = true;
            },
            editRow(item) {
                this.editedIndex = this.Zones.indexOf(item);
                this.zoneItem = Object.assign({}, item);
                this.zoneDialog = true;
            },
            closeZonesDialog() {
                this.zoneDialog = false;
                this.editedIndex = -1;
            },
            // @vuese
            // Gets all the regions.
            getRegions() {
                axios.get(process.env.API_URL + '/regions')
                    .then((response) => {
                        this.regions = response.data;
                    })
                    .catch((response) => {
                         this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    })
            },
            // @vuese
            // Gets all the depots.
            getDepots() {
                axios.get(process.env.API_URL + '/depots')
                    .then((response) => {
                        this.depots = response.data;
                    })
                    .catch((response) => {
                         this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    })
            },
            saveChanges() {
                let body = this.zoneItem;

                if (this.editedIndex > -1) {
                    axios.put(process.env.API_URL + '/zones/' + this.zoneItem.id, body)
                        .then((response) => {
                            this.$store.commit('displaySnackbar', "Changes saved");
                            this.updateDataTable();
                        })
                        .catch((response) => {
                            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);

                        })
                } else {
                    if (body.name === null) {
                        this.$store.commit('displaySnackbar', 'Please select a name for the zone');
                        return false;
                    }

                    axios.post(process.env.API_URL + '/zones', body)
                        .then((response) => {
                            this.$store.commit('displaySnackbar', 'Create successful');
                            this.updateDataTable();
                        })
                        .catch((response) => {
                            this.$store.commit('displaySnackbar', 'ERROR: Create failed');
                        })
                }
                this.closeZonesDialog();
            },
            deleteRow(item) {
                this.toBeDeleted = item;
                this.deleteDialog = true;
            },
            deleteZone() {
                let index = this.Zones.indexOf(this.toBeDeleted);
                axios.delete(process.env.API_URL + '/depots/' + this.toBeDeleted.id)
                    .then((response) => {
                        this.$store.commit('displaySnackbar', 'Detete successful');
                        this.Zones.splice(index, 1);
                        this.deleteDialog = false;
                        this.updateDataTable();
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    })
            },

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/GlobalAdmin/ManageZones.vue